import { render, staticRenderFns } from "./EnvironmentDialog.vue?vue&type=template&id=4a0ed8c6"
import script from "./EnvironmentDialog.vue?vue&type=script&lang=js"
export * from "./EnvironmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports